import { useAuth } from '../contexts/AuthContext'
import { generateGradientFromUsername } from '../utils/profilePicture'
import { useNavigate } from 'react-router-dom'
import './Dashboard.css'

const Dashboard = () => {
  const { user } = useAuth()
  const navigate = useNavigate()

  if (!user) {
    navigate('/')
    return null
  }

  return (
    <main className="main-content dashboard-page">
      <div className="dashboard-container">
        <div className="dashboard-header">
          <h1 
            className="dashboard-username"
            style={{ background: generateGradientFromUsername(user.username) }}
          >
            {user.username}
          </h1>
          <p className="dashboard-welcome">welcome to your dashboard</p>
        </div>
        
        <div className="dashboard-content">
          <div className="dashboard-card">
            <h2 className="dashboard-card-title">quick actions</h2>
            <div className="dashboard-actions">
              <button 
                className="dashboard-action-button"
                onClick={() => navigate('/community?tab=forum')}
              >
                <i className="fas fa-comments"></i>
                <span>go to forum</span>
              </button>
              <button 
                className="dashboard-action-button"
                onClick={() => navigate('/community?tab=creations')}
              >
                <i className="fas fa-palette"></i>
                <span>share creation</span>
              </button>
              <button 
                className="dashboard-action-button"
                onClick={() => navigate('/community?tab=tutorials')}
              >
                <i className="fas fa-book"></i>
                <span>view tutorials</span>
              </button>
              <button 
                className="dashboard-action-button"
                onClick={() => navigate('/settings')}
              >
                <i className="fas fa-cog"></i>
                <span>settings</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>
  )
}

export default Dashboard

